/**
 * Which primary member-area tab matches the current URL (navbar + bottom nav).
 * Order matters: more specific paths before the broad "dashboard" match.
 */
export type MemberNavKey = "dashboard" | "explore" | "journal" | "library" | "profile";

export function getMemberNavActiveKey(pathname: string): MemberNavKey | "other" {
  const p = pathname;
  if (/\/(explorar|dashboard\/explore)(\/|$)/.test(p)) return "explore";
  if (p.includes("/panel/diario") || /\/dashboard\/journal(\/|$)/.test(p)) return "journal";
  if (p.includes("/biblioteca") || /\/dashboard\/library(\/|$)/.test(p)) return "library";
  if (p.includes("/perfil") || /\/profile(\/|$)/.test(p)) return "profile";
  if (p.includes("/reproductor") || /\/dashboard\/player(\/|$)/.test(p)) return "other";
  if (p.includes("/panel") || p.includes("/dashboard")) return "dashboard";
  return "other";
}
